import { cn } from "@/utils/utils";
import type { TradingToolRangeSliderProps } from "@/types/tradingTool";

const THUMB_SIZE_PX = 14;

function getThumbLeftPercent(value: number, min: number, max: number) {
  const safeMax = max > min ? max : min + 1;
  return ((value - min) / (safeMax - min)) * 100;
}

export default function TradingToolRangeSlider({
  value,
  min,
  max,
  step = 1,
  onChange,
  formatValue,
  className,
}: TradingToolRangeSliderProps) {
  const safeMax = max > min ? max : min + 1;
  const percent = getThumbLeftPercent(value, min, max);
  const thumbLeft = `calc(${(percent / 100).toFixed(4)} * (100% - ${THUMB_SIZE_PX}px) + ${THUMB_SIZE_PX / 2}px)`;

  return (
    <div className={cn("relative pt-0", className)}>
      <span
        className="pointer-events-none absolute -top-6 z-20 -translate-x-1/2 whitespace-nowrap font-neue text-sm font-semibold tabular-nums text-white"
        style={{ left: thumbLeft }}
        aria-hidden
      >
        {formatValue(value)}
      </span>

      <div className="relative h-5">
        <div className="absolute left-0 right-0 top-1/2 h-0.5 -translate-y-1/2 rounded-full bg-white/10" />
        <div
          className="absolute left-0 top-1/2 h-0.5 -translate-y-1/2 rounded-full bg-gradient-to-r from-[#1CCDE6] via-[#9ED473] to-[#DBD633]"
          style={{ width: thumbLeft }}
        />
        <input
          type="range"
          min={min}
          max={safeMax}
          step={step}
          value={value}
          onChange={(event) => onChange(Number(event.target.value))}
          aria-valuetext={formatValue(value)}
          className="equity-simulator-range absolute inset-0 z-10 h-5 w-full cursor-pointer appearance-none bg-transparent"
          style={{ ["--range-percent" as string]: `${percent}%` }}
        />
      </div>
    </div>
  );
}
